import { useUsersForm } from "../users/useUsersForm";
import {
  submitUsers,
  submitRoles,
  submitCustomerReportRequests,
  submitReverseTransactions,
  submitMarkTransaction,
  submitLiquidations,
  submitDebitHolding,
  submitCreditHolding,
  submitPartnerItemMapping,
} from "../submission/useSubmission";
import { useRolesForm } from "../roles/useRolesForm";
import {
  submitConfigurables,
  useConfigurablesForm,
} from "../configurables/useConfigurablesForm";

import {
  locationFormRoutes,
  locationFormSubmit,
} from "../../components/pages/location/LocationRoute";
import { officesFormRoutes } from "../../components/pages/offices/OfficesRoutes";
import {
  onPasswordResetFormSubmit,
  usePasswordResetForm,
} from "../users/usePasswordResetForm";

import {
  submitLoanApplication,
  useLoanApplicationForm,
} from "../loan_applications/useLoanApplicationForm";
import {
  submitInterestConfigurables,
  useInterestConfigurablesForm,
} from "../configurables/useInterestConfigurablesForm";
import {
  submitPeriodConfigurables,
  usePeriodConfigurablesForm,
} from "../configurables/usePeriodConfigurablesForm";
import {
  submitFeesConfigurables,
  useFeesConfigurablesForm,
} from "../configurables/useFeesConfigurablesForm";
import {
  submitCOAConfigurables,
  useChartsOfAccountConfigurablesForm,
} from "../configurables/useCOAConfigurablesForm";
import {
  submitSupplierConfigurables,
  useSupplierConfigurablesForm,
} from "../configurables/useSupplierConfigurablesForm";
import {
  submitPurchaseOrder,
  usePurchaseOrderForm,
} from "../purchase_orders/usePurchaseOrderForm";
import {
  submitInventory,
  useInventoryForm,
} from "../inventory/useInventoryForm";
import { submitPayroll, usePayrollForm } from "../payroll/usePayrollForm";
import {
  submitAllowanceTypeConfigurables,
  useAllowanceTypeConfigurablesForm,
} from "../configurables/useAllowanceTypeConfigurablesForm";
import { submitExpense, useExpenseForm } from "../expenses/useExpenseForm";
import {
  submitOtherIncome,
  useOtherIncomeForm,
} from "../other_income/useOtherIncomeForm";
import {
  submitOrganisations,
  useOrganisationForm,
} from "../organisations/useOrganisations";
import {
  submitProductChangeStatusForm,
  submitProductForm,
  useProductChangeStatusForm,
  useProductForm,
} from "../inventory/useProductForm";
import {
  submitMakePayment,
  useMakePaymentForm,
} from "../payments/useMakePaymentForm";
import {
  submitRequisition,
  useRequisitionForm,
} from "../requisition/useRequisitionForm";
import { submitLedgers, useLedgersForm } from "../ledgers/useLedgersForm";
import { submitPayments, usePaymentsForm } from "../payments/usePaymentsForm";
import {
  submitLoanApplicationReschedule,
  useRescheduleForm,
} from "../loan_applications/reshedule/useRescheduleForm";
import {
  submitPaymentModesConfigurables,
  usePaymentModesConfigurablesForm,
} from "../configurables/usePaymentModesConfigurablesForm";
import { submitFines, useFinesForm } from "../fines/useFinesForm";
import { useYoyaChargesForm } from "../services/charges/useYoyaCharges";
import { useMerchantFeesForm } from "../agent_management/useMerchantFees";
import {
  submitPaymentServices,
  usePaymentServicesForm,
} from "../payment_services/usePaymentServices";
import useCustomerReportRequestsForm from "../system_reports/utility_logs/useCustomerReportRequestsForm";
// import {
//   useWalletDepositForm,
//   useWalletTransferForm,
// } from "../wallet_transfers/useWalletTransfers";
import { usePartnerItemMappingForm } from "../transaction_processing/usePartnerItemMapping";
import { useReSetWalletPinForm } from "../users/useResetWalletPinForm";
import { useReverseTransactionsForm } from "../transaction_processing/useReverseTransactions";
import { useMarkTransactionForm } from "../transaction_processing/useMarkTransaction";
import { useWorkflowsForm } from "../workflows/useWorkflows";
import { useScrutinyWorkflowsForm } from "../workflows/useScrutinyWorkflows";
import {
  submitMerchantServiceAccess,
  useMerchantServiceAccessForm,
} from "../agent_management/useMerchantServiceAccess";
import { usePaymentAccessMatrixForm } from "../internal_merchant_access/useInternalMerchantAccess";
import {
  submitPaymentItems,
  usePaymentItemsForm,
} from "../accounting/usePaymentItems";
import { submitPartners, usePartnersForm } from "../accounting/usePartners";
import { usePartnerChargesForm } from "../accounting/usePartnerCharges";
import {
  submitChargeAssignment,
  useChargeAssignmentForm,
} from "../accounting/useChargeAssignment";
import {
  submitPaymentTypes,
  usePaymentTypesForm,
} from "../accounting/usePaymentTypes";
import { useMerchantUserForm } from "../users/useMerchantUsers";
import {
  submitSystemWallets,
  useSystemWalletsForm,
} from "../accounting/useSystemWallets";
import { useLiquidationsConfigurablesForm } from "../configurables/useLiquidationsConfigurablesForm";
import {
  submitDynamicQRcode,
  useDynamicQRcodeForm,
} from "../qr_codes/useDynamicQRcode";
import {
  submitFraudRules,
  useFraudRulesForm,
} from "../fraud_detection/useFraudRules";
import { useMerchantCodeForm } from "../agent_management/useMerchantCodes";
import { useFraudWeightScoreForm } from "../fraud_detection/useFraudWeightScore";
import {
  submitFraudConfigurations,
  useFraudConfigurationsForm,
} from "../fraud_detection/useFraudConfigurations";
import { useMerchantIPWhitelistForm } from "../agent_management/useMerchantIPWhitelist";
import { useUSSDMerchantsForm } from "../ussd_services/useUSSDMerchants";
import { useUSSDConfigurablesForm } from "../ussd_services/useUSSDConfigurables";
import {
  submitMonitoredAccounts,
  useMonitoredAccountsForm,
} from "../float_management/useMonitoredAccounts";
import {
  submitCreditHoldingTypes,
  useCreditHoldingTypesForm,
} from "../float_management/useCreditHoldingTypes";
import {
  submitDebitHoldingTypes,
  useDebitHoldingTypesForm,
} from "../float_management/useDebitHoldingTypes";
import {
  submitLiquidationBankCodes,
  useLiquidationBankCodesForm,
} from "../float_management/useLiquidationBankCodes";
import {
  submitBankAccounts,
  useBankAccountsForm,
} from "../float_management/useBankAccounts";
import { useReplenishmentForm } from "../float_management/useReplenishment";
import { useLiquidationsForm } from "../float_management/useLiquidations";
import { useDebitHoldingForm } from "../float_management/useDebitHolding";
import { useCreditHoldingForm } from "../float_management/useCreditHolding";
import {
  submitCompositeItems,
  useCompositeItemsForm,
} from "../composite_items/useCompositeItemsForm";
import { useFloatInterestConfigsForm } from "../finance_and_treasury/revenue_sharing/useFloatInterestConfigs";
import { useSettlementBatchForm } from "../finance_and_treasury/settlement_engine/useSettlementBatches";
import { useSettlementRulesForm } from "../finance_and_treasury/settlement_engine/useSettlementRules";
import { useSettlementBeneficiariesForm } from "../finance_and_treasury/settlement_engine/useSettlementBeneficiaries";
import {
  submitIncidentTicketing,
  useIncidentTicketingForm,
} from "../incident_ticketing/useIncidentTicketingForm";
import {
  submitTicketCategorization,
  useTicketCategorizationForm,
} from "../ticket_categorization/useTicketCategorizationForm";
import {
  submitTicketResolution,
  useTicketResolutionForm,
} from "../ticket_resolution/useTicketResolutionForm";
import {
  submitTicketClosure,
  useTicketClosureForm,
} from "../ticket_closure/useTicketClosureForm";
import {
  submitTicketEscalation,
  useTicketEscalationForm,
} from "../ticket_escalation/useTicketEscalationForm";

// handle form creation
export const formHooks: Record<string, any> = {
  customer_report_requests: useCustomerReportRequestsForm,
  users: useUsersForm,
  loan_application: useLoanApplicationForm,
  loan_application_reschedule: useRescheduleForm,
  roles: useRolesForm,
  // TRANSACTION PROCESSING
  partner_item_mapping: usePartnerItemMappingForm,
  reverse_transactions: useReverseTransactionsForm,
  mark_transaction: useMarkTransactionForm,
  liquidations: useLiquidationsForm,
  monitored_accounts: useMonitoredAccountsForm,
  credit_holding_types: useCreditHoldingTypesForm,
  debit_holdings_types: useDebitHoldingTypesForm,
  liquidation_bank_codes: useLiquidationBankCodesForm,
  bank_accounts: useBankAccountsForm,
  debit_holdings: useDebitHoldingForm,
  credit_holdings: useCreditHoldingForm,

  purchase_order: usePurchaseOrderForm,
  inventory: useInventoryForm,
  other_income: useOtherIncomeForm,
  // Expenses
  expenses: useExpenseForm,
  requisitions: useRequisitionForm,
  // PAYROLL
  payrolls: usePayrollForm,
  // CONFIGURABLES
  configurables: useConfigurablesForm,
  interest_configurables: useInterestConfigurablesForm,
  period_configurables: usePeriodConfigurablesForm,
  fees_schedule_configurables: useFeesConfigurablesForm,
  charts_of_accounts_configurables: useChartsOfAccountConfigurablesForm,
  supplier_configurables: useSupplierConfigurablesForm,
  allowance_types_configurables: useAllowanceTypeConfigurablesForm,
  payment_modes_configurables: usePaymentModesConfigurablesForm,
  // MASTER DATA
  ...locationFormRoutes,
  // OFFICES
  ...officesFormRoutes,
  // PASSWORD RESET
  password_reset: usePasswordResetForm,
  // PASSWORD RESET
  reset_pin: useReSetWalletPinForm,
  // SERVICES
  payment_items: usePaymentItemsForm,
  partners: usePartnersForm,
  merchant_fees: useMerchantFeesForm,
  merchant_service_access: useMerchantServiceAccessForm,
  // CHARGES
  yoya_charges: useYoyaChargesForm,
  partner_charges: usePartnerChargesForm,
  charge_assignment: useChargeAssignmentForm,
  // ORGANISATIONS
  organisations: useOrganisationForm,
  // LEDGERS
  ledgers: useLedgersForm,
  // PRODUCTS
  products: useProductForm,
  products_change_status: useProductChangeStatusForm,
  // PAYMENTS
  make_payment: useMakePaymentForm,
  payments: usePaymentsForm,
  composite_items: useCompositeItemsForm,
  // FINES
  fines: useFinesForm,
  //PAYMENT SERVICES
  payment_services: usePaymentServicesForm,
  //PAYMENT SERVICES
  // wallet_deposit: useWalletDepositForm,
  // wallet_transfer: useWalletTransferForm,
  //PAYMENT TYPES
  payment_types: usePaymentTypesForm,

  //FlOAT MANAGEMENT
  replenishment: useReplenishmentForm,

  //WORKFLOWS
  workflows: useWorkflowsForm,
  scrutiny_workflows: useScrutinyWorkflowsForm,

  //PAYMENT ACCESS MATRIX
  internal_merchant_access: usePaymentAccessMatrixForm,

  //MERCHANT USERS
  merchant_users: useMerchantUserForm,
  merchant_ip_whitelist: useMerchantIPWhitelistForm,

  system_wallets: useSystemWalletsForm,
  //FINANCE AND TREASURY
  float_interest_configs: useFloatInterestConfigsForm,
  settlement_batches: useSettlementBatchForm,
  settlement_rules: useSettlementRulesForm,
  settlement_beneficiaries: useSettlementBeneficiariesForm,

  liquidation_configurations: useLiquidationsConfigurablesForm,
  // QR CODES
  dynamic_qr_code: useDynamicQRcodeForm,

  // FRAUD DETECTION
  fraud_rules: useFraudRulesForm,
  fraud_weight_score: useFraudWeightScoreForm,
  fraud_configurations: useFraudConfigurationsForm,

  //MERCHANT CODES
  merchant_codes: useMerchantCodeForm,

  //USSD SERVICE
  set_ussd_merchant: useUSSDMerchantsForm,
  ussd_configurables: useUSSDConfigurablesForm,

  //SUPPORT
  incident_ticketing: useIncidentTicketingForm,
  ticket_categorization: useTicketCategorizationForm,
  ticket_resolution: useTicketResolutionForm,
  ticket_closure: useTicketClosureForm,
  ticket_escalation: useTicketEscalationForm,
};

// handle form submission
export const formSubmitHooks: Record<string, any> = {
  customer_report_requests: submitCustomerReportRequests,
  users: submitUsers,
  loan_application: submitLoanApplication,
  loan_application_reschedule: submitLoanApplicationReschedule,
  purchase_order: submitPurchaseOrder,
  inventory: submitInventory,
  other_income: submitOtherIncome,

  // Expenses
  requisitions: submitRequisition,
  expenses: submitExpense,

  // PAYROLL
  payrolls: submitPayroll,
  // ROLES
  roles: submitRoles,
  // TRANSACTION PROCESSING
  reverse_transactions: submitReverseTransactions,
  partner_item_mapping: submitPartnerItemMapping,
  mark_transaction: submitMarkTransaction,
  liquidations: submitLiquidations,
  monitored_accounts: submitMonitoredAccounts,
  credit_holding_types: submitCreditHoldingTypes,
  debit_holdings_types: submitDebitHoldingTypes,
  liquidation_bank_codes: submitLiquidationBankCodes,
  bank_accounts: submitBankAccounts,
  debit_holdings: submitDebitHolding,
  credit_holdings: submitCreditHolding,

  // CONFIGURABLES
  configurables: submitConfigurables,
  interest_configurables: submitInterestConfigurables,
  period_configurables: submitPeriodConfigurables,
  fees_schedule_configurables: submitFeesConfigurables,
  charts_of_accounts_configurables: submitCOAConfigurables,
  supplier_configurables: submitSupplierConfigurables,
  allowance_types_configurables: submitAllowanceTypeConfigurables,
  payment_modes_configurables: submitPaymentModesConfigurables,
  // MASTER DATA
  ...locationFormSubmit,
  organisations: submitOrganisations,
  // PRODUCT
  products: submitProductForm,
  products_change_status: submitProductChangeStatusForm,
  // PAYMENTS
  make_payment: submitMakePayment,
  payments: submitPayments,
  payment_items: submitPaymentItems,
  partners: submitPartners,
  charge_assignment: submitChargeAssignment,
  composite_items: submitCompositeItems,
  // PASSWORD RESET
  password_reset: onPasswordResetFormSubmit,
  // PIN SET
  // reset_pin: onResetWalletPinFormSubmit,
  // LEDGERS
  ledgers: submitLedgers,
  // FINES
  fines: submitFines,
  //PAYMENT SERVICES
  payment_services: submitPaymentServices,
  //WALLET TRANSFERS
  // wallet_deposit: submitWalletTransfers,

  //PAYMENT TYPES
  payment_types: submitPaymentTypes,
  //MERCHANT SERVICE ACCESS
  merchant_service_access: submitMerchantServiceAccess,

  system_wallets: submitSystemWallets,

  // QR CODES
  dynamic_qr_code: submitDynamicQRcode,

  // FRAUD DETECTION
  fraud_rules: submitFraudRules,
  fraud_configurations: submitFraudConfigurations,

  //SUPPORT
  incident_ticketing: submitIncidentTicketing,
  ticket_categorization: submitTicketCategorization,
  ticket_resolution: submitTicketResolution,
  ticket_closure: submitTicketClosure,
  ticket_escalation: submitTicketEscalation,
};
